import React, { useState, useContext } from "react";
import { Button } from "components/button";
import BottomBar from "components/bottom-bar";
import { useGenerateShipping } from "api/use-shipping";
import { useLocation } from "react-router-dom";
import { getQueryParams } from "lib/utils";
import AuthContext from "contexts/AuthContext";

export default function ShippingLabel() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const queryParams = getQueryParams(location.search);

  const { authTokens } = useContext(AuthContext);

  const generateShipping = useGenerateShipping({
    onSuccess: (data) => {
      setIsSubmitting(false);
      // Extract the label URL from the response and open it immediately
      const shippingData = data?.data?.[0];
      const originalLabelUrl = shippingData?.shipping_metadatas?.items?.find(
        (item) => item.key === "label_url"
      )?.value;

      if (originalLabelUrl && queryParams?.takebackId) {
        try {
          const url = new URL(originalLabelUrl);
          const returnID = url.searchParams.get("returnID");

          if (returnID && authTokens?.access_token) {
            const labelUrl = `${window.location.origin}/api/pdf/shipping-label-no-instructions?returnID=${returnID}&token=${authTokens.access_token}`;
            // Open PDF in new tab for printing
            window.open(labelUrl, "_blank");
          } else {
            window.open(originalLabelUrl, "_blank");
          }
        } catch (error) {
          console.error("Error constructing label URL:", error);
          window.open(originalLabelUrl, "_blank");
        }
      }
    },
    onError: () => {
      setIsSubmitting(false);
      window.alert("Failed to create shipping label");
    },
  });

  const handlePrintLabel = () => {
    setIsSubmitting(true);
    generateShipping.mutate({
      takeback_id: queryParams?.takebackId,
      customer_id: queryParams?.customerId,
      type: "MAIL_LABEL",
    });
  };

  return (
    <div className="flex flex-col h-[calc(100vh-81px)]">
      <div className="flex flex-grow flex-col items-center justify-center px-6 py-4">
        <h1 className="text-6xl font-bold text-center mb-2">
          Shipping Label Ready
        </h1>
        <p className="text-center  sm:max-w-sm text-xl mb-10">
          A shipping label has been generated and is ready to be printed and
          attached to the receptacle.
        </p>
        <Button
          onClick={handlePrintLabel}
          className="w-full max-w-sm py-6 mb-6"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Creating Label..." : "Print Shipping Label"}
        </Button>
        <a
          href="create-shipment"
          className="text-center text-[#1f6cb7] text-xl"
        >
          Done
        </a>
      </div>
      <BottomBar />
    </div>
  );
}
